import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { DialogCloseResult } from '@progress/kendo-angular-dialog';
import { VennHealthDataService } from '../../../services/vennhealth-data.service';
import { VennHealthDialogService } from '../../../services/vennhealth-dialog.service';
import { SharedService } from '../../../services/shared.service';
import { environment } from '../../../../environments/environment';
import { FilterModel } from '@app/models/filter-model';
import { VennHealthHelpers } from '@app/shared/vennHealthHelpers';
import { IndicationGroup } from '@app/models/indication';

@Component({
  selector: 'app-query-card',
  templateUrl: './query-card.component.html',
  styleUrls: ['./query-card.component.css'],
})
export class QueryCardComponent implements OnInit {
  @Input() public savedQuery: boolean = false;
  @Input() public query: any;
  @Output() public loadSelectedSavedQuery = new EventEmitter();

  allIndications: IndicationGroup[] = [];
  activeQueryName = '';
  activeQueryId = 0;

  constructor(
    private readonly vennHealthDataService: VennHealthDataService,
    private readonly sharedService: SharedService,
    private readonly vennHealthDialogService: VennHealthDialogService
  ) {}

  ngOnInit(): void {
    this.sharedService.allIndications.subscribe(data => {
      if (data) {
        this.allIndications = data;
      }
    });

    this.sharedService.activeQueryName.subscribe(data => {
      if (data !== null) {
        this.activeQueryName = data;
      }
    });

    this.sharedService.activeQueryId.subscribe(data => {
      if (data !== null) {
        this.activeQueryId = data;
      }
    });
  }

  loadQuery(dataItem: any): void {
    this.getQueryDetails(dataItem.queryId, dataItem.queryName);
  }

  deleteSavedQuery(dataItem: any): void {
    if (dataItem.hasOwnProperty('queryId')) {
      const title = "Delete Saved Query";
      const message = `Are you sure want to delete "${dataItem.queryName}"?`
      this.vennHealthDialogService.showDeleteDialog(title, message).subscribe(
        (result) => {
          if (result instanceof DialogCloseResult) {
            console.log('close');
          } else {
            console.log('action', result);
            if (result.text === 'Confirm Delete') {
              this.vennHealthDataService.deleteSavedFilter(dataItem.queryId).subscribe({
                next: (data) => {
                  if (data) {
                    this.vennHealthDialogService.showNotification(`Successfully deleted Saved Query named "${dataItem.queryName}".`);
                    this.sharedService.setRefreshSavedQueries();
                    // if we just deleted the currently selected filter, set the active query name to the default 
                    if (this.activeQueryName.toLowerCase() === dataItem.queryName.toLowerCase()) {
                      const activeQueryName = `${environment.defaultQueryName} ${new Date(Date.now()).toLocaleDateString()}`;
                      this.sharedService.setActiveQueryName(activeQueryName);
                    }
                  }
                },
                error: (e) => {
                  this.vennHealthDialogService.showNotification(`Saved query named ${dataItem.queryName} failed to delete properly.`, {style: 'error', icon: true });
                },
                complete: () => {
                  console.info('complete delete query');
                }
            });
          }
        }
      });
    }
  }

  // this is from the query history tab. when an item it clicked this is where it goes to load the saved query
  private getQueryDetails(queryId: string, queryName: string): void {
    this.vennHealthDataService.getExecutedQuery(queryId).subscribe({
      next: (data) => {
        if (data) {
          this.allIndications.forEach(group => {
            group.indications.forEach(i => {
              let savedIndication = VennHealthHelpers.getCurrentIndicationFromIndicationGroupJson(i, data.indicationGroups);
              // update only the selected and selections properties so we retain the inputOptions, labels, ect used by the UI only
              i.selected = savedIndication.selected;
              i.selections = savedIndication.selections;
            });
          });
          this.sharedService.setAllIndications(this.allIndications);
          this.sharedService.setActiveSavedFilters(data);
          this.sharedService.setSeletedDataSets(data.dataSets);
          this.sharedService.setActiveQueryName(queryName);
        }
      },
      error: (e) => {
        this.vennHealthDialogService.showOkDialog('Query Load Failed',
        `Query filters for ${queryName} failed to load properly.`);
      },
      complete: () => {
        console.info('complete query details get');
      }
    });
  }

  loadSavedQuery(dataItem: any): void {
    this.loadSelectedSavedQuery.emit(dataItem);
  }

  displaySelectedDataSets(query: FilterModel): string {
    const dataSetsString = query.dataSets.map(i => i['text']).toString();
    return dataSetsString;
  }

  displaySelectedFilteredIndicationNames(query: FilterModel): string {
    const selectedNames = [];
    query.indicationGroups.forEach(g => {
      g.indications.forEach(i => {
        if (i.selected) {
          selectedNames.push(i.displayName);
        }
      });
    });
    return `(${selectedNames.length}) ${selectedNames.toString()}`;
  }
  
}
